import { path } from "../../config";
import { store } from "../../redux/store";
import fetchServer from "../fetchServer";

export async function adminPayHotel(id,userId,data) {
  var result = {return: 0,msg: 'Error',data: {}}

  let token = store.getState().user.userData.accessToken;

  let headers = {
    Authorization: `Bearer ${token}`
  }

  if(userId)
    headers['user-id'] = userId;

  
  await fetchServer({method: "PATCH",url: path.api+'/hotels/pay-for-order/manual/'+id,data,
    headers
  })
  .then((res) => {
    console.log(" => ",res)
    if(res) {
      if(res?.data?.success) {
        result = {return: 1,msg: "Successfull",data: res.data.data};
      } else if(res.error) result['msg'] = res.error.message;
    } 
  })
  .catch((err) => {
    console.log("Network Error: ",err);
  })

  return result;

}